const ApaItuRobotika: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">🤖 Apa Itu Robotika? Pengantar Singkat untuk Pemula</h2>

            <p className="mb-4">
                Robotika adalah cabang ilmu multidisiplin yang memadukan <strong>mekanika</strong> (gerakan dan struktur fisik robot), <strong>elektronika</strong> (penggunaan sensor, aktuator, dan rangkaian kontrol), serta <strong>pemrograman</strong> (logika dan instruksi digital) untuk menciptakan mesin cerdas yang mampu melakukan tugas tertentu secara otomatis.

            </p>

            <p className="mb-4">
                Dalam istilah sederhana, robotika adalah seni dan sains merancang, membangun, dan mengendalikan robot. Robot sendiri adalah perangkat yang bisa:
                <ul className="list-disc ml-5 mt-2 mb-2">
                    <li>Berinteraksi dengan lingkungannya melalui sensor</li>
                    <li>Mengambil keputusan melalui pemrosesan data</li>
                    <li>Melakukan aksi fisik melalui motor dan aktuator</li>
                </ul>
            </p>

            <h3 className="text-md font-semibold mb-2">🔍 Contoh Robotika di Sekitar Kita</h3>
            <p className="mb-4">
                Kamu mungkin tidak sadar, tapi teknologi robotik sudah ada di sekitarmu setiap hari. Beberapa contoh yang umum dijumpai meliputi:
                <ul className="list-disc ml-5 mt-2 mb-2">
                    <li>🧹<strong>Vacuum cleaner otomatis</strong> mampu mendeteksi dinding, tangga, dan kotoran tanpa bantuan manusia.</li>
                    <li>🏭<strong>Lengan robot industri</strong> digunakan untuk merakit, mengelas, atau mengecat secara konsisten di pabrik.</li>
                    <li>🚗<strong>Mobil self-driving</strong> mengandalkan kombinasi kamera, radar, dan kecerdasan buatan untuk menavigasi jalan.</li>
                    <li>🤖<strong>Robot edukatif</strong> digunakan di sekolah untuk membantu anak-anak belajar logika dan pemrograman dasar.</li>
                </ul>
            </p>

            <h3 className="text-md font-semibold mb-2">🎯 Tujuan Utama Robotika</h3>
            <p className="mb-4">
                Robotika dikembangkan dengan satu tujuan utama: <strong>membantu dan menggantikan manusia</strong> dalam melakukan pekerjaan yang memiliki karakteristik tertentu, seperti:
                <ul className="list-disc ml-5 mt-2">
                    <li>🔁<strong>Tugas berulang</strong> seperti memindahkan barang di jalur produksi</li>
                    <li>🧨<strong>Lingkungan berbahaya</strong> seperti penjinakan bom, penambangan bawah tanah, atau eksplorasi luar angkasa</li>
                    <li>📈<strong>Butuh ketelitian tinggi</strong> seperti operasi bedah menggunakan lengan robot</li>
                    <li>⏱️<strong>Kebutuhan efisiensi waktu dan energi</strong> seperti robot pengantar barang di gudang</li>
                </ul>
            </p>

            <h3 className="text-md font-semibold mb-2">🧠 Apa yang Dipelajari dalam Robotika?</h3>
            <p className="mb-4">
                Untuk menjadi seseorang yang memahami robotika, kamu tidak harus langsung belajar semuanya sekaligus. Bidang ini terbagi dalam beberapa aspek penting:
                <ul className="list-disc mt-2 mb-2 ml-5">
                    <li><strong>Mekanik</strong>: Desain rangka dan struktur robot agar kuat dan efisien.</li>
                    <li><strong>Elektronik</strong>: Rangkaian listrik, penggunaan sensor, dan pengontrol seperti Arduino atau Raspberry Pi.</li>
                    <li><strong>Kontrol</strong>: Mengatur gerakan robot menggunakan motor dan logika pemrograman.</li>
                    <li><strong>Pemrograman</strong>: Menulis kode agar robot bisa merespons lingkungan (biasanya menggunakan Python, C/C++, atau Blockly).</li>
                    <li><strong>Kecerdasan buatan</strong>: Untuk membuat robot lebih &quot;cerdas&quot;, seperti bisa mengenali wajah atau menghindari rintangan sendiri.</li>
                </ul>
            </p>

            <h3 className="text-md font-semibold mb-2">🧪 Bagaimana Cara Mulai Belajar Robotika?</h3>
            <p className="mb-4">
                Kamu bisa memulai dari proyek kecil dan murah, seperti merakit <strong>robot line follower</strong> atau <strong>robot tangan sederhana</strong>. Banyak kit robot yang bisa dibeli secara online dan disertai dengan panduan.
            </p>
            <p className="mb-4">
                Beberapa tips untuk pemula:
                <ul className="list-disc ml-5 mt-2">
                    <li>🛠️ Gunakan kit berbasis Arduino, mudah diprogram dan banyak dokumentasi</li>
                    <li>📹 Ikuti video tutorial dari YouTube, gratis dan cocok untuk belajar visual</li>
                    <li>📚 Baca dokumentasi resmi dan forum seperti Arduino, Stack Overflow, atau Reddit</li>
                    <li>🤝 Ikut komunitas, bisa diskusi dan ikut lomba robotik di sekolah atau kampus</li>
                </ul>
            </p>

            <h3 className="text-md font-semibold mb-2">🚀 Masa Depan Robotika</h3>
            <p className="mb-4">
                Dunia robotika terus berkembang. Dari robot pembersih rumah hingga robot medis yang bisa membantu operasi jarak jauh, teknologi ini akan terus berperan besar dalam kehidupan manusia.
            </p>
            <p className="mb-4">
                Bahkan saat ini, perusahaan seperti Tesla, Boston Dynamics, dan NASA sedang mengembangkan robot yang bisa:
                <ul className="list-disc ml-5 mt-2 mb-2">
                    <li>Berjalan seperti manusia di lingkungan yang kompleks</li>
                    <li>Berinteraksi secara sosial dengan manusia</li>
                    <li>Bekerja di luar angkasa atau permukaan planet lain</li>
                </ul>
            </p>

            <p className="text-gray-700">
                Robotika bukan hanya untuk insinyur atau ilmuwan, siapa saja bisa mulai belajar dengan niat dan rasa ingin tahu. Dunia robot menantimu. Yuk, mulai dari yang kecil dan eksplorasi kreatifmu sekarang juga! 🤩
            </p>

        </div>

    )
}
export default ApaItuRobotika